// src/services/CountryService.js
import api from "./api";

export function getLanguages(page = 1, limit = 10) {
    return api.get(
        `/language?page=${page}&limit=${limit}&list=all`
    );
}
